import React, { PropTypes } from 'react'
import { Form } from 'react-redux-form/immutable'
import { Row, Field } from 'react-gridforms'
import Input from 'bisu-react-input'
import errBlock from 'bisu-react-form-error'

import FieldGroupRow from 'components/FieldGroupRow'
import { required } from 'utils/validators'

const similar = (model) => model.get('npassword') === model.get('npassword2')
const validators = {
  '': { similar },
  'cpassword': { required },
  'npassword': { required },
  'npassword2': { required },
}

const FormChangePassword = ({ onSubmit, isPending }) => {
  const submitText = isPending ? 'Updating password...' : 'Update Password'

  return (
    <div className="row">
      <div className="col-sm-5">
        <h5>Change Password</h5>
        <p className="text-muted">Change account password.</p>
      </div>
      <div className="col-sm-6">
        <Form
          model="passwordState"
          validators={validators}
          className="grid-form"
          onSubmit={onSubmit}
        >
          <FieldGroupRow
            model=".cpassword"
            label="Current Password"
            type="password"
            required
            autoFocus
          />
          <FieldGroupRow
            model=".npassword"
            label="New Password"
            type="password"
            required
          />
          <Row>
            <Field>
              <Input
                model=".npassword2"
                label="Confirm New Password"
                type="password"
                required
              />
              {errBlock('passwordState')}
            </Field>
          </Row>
          <div className="m-t-20 text-right">
            <button type="submit" disabled={isPending} className="btn btn-primary">{submitText}</button>
          </div>
        </Form>
      </div>
    </div>
  )
}

FormChangePassword.propTypes = {
  isPending: PropTypes.bool,
  onSubmit: PropTypes.func,
}

export default FormChangePassword



// WEBPACK FOOTER //
// ./src/containers/Account/form-change-password.js